import { update as intercomUpdate } from '@intercom/messenger-js-sdk';
import useResizeObserver from '@react-hook/resize-observer';
import React from 'react';

/**
 * Updates horizontal padding of Intercom widget.
 * Zero specifies default padding (set in Intercom UI).
 * @param {number} horizontalPadding - pixels (0 = default)
 */
function updateIntercomWidget(horizontalPadding: number) {
  intercomUpdate({
    alignment: 'right',
    horizontal_padding: horizontalPadding,
  });
}

/**
 * Positions the Intercom widget to the left of the right panel when it expands / collapses.
 * @returns A ref to be attached to the right panel.
 */
export const useIntercomWidgetPositioner = <T extends HTMLElement>() => {
  const rightMenuRef = React.useRef<T>(null);

  useResizeObserver(rightMenuRef, (entry) => {
    updateIntercomWidget(entry.contentRect.width > 0 ? entry.contentRect.width + 20 : 0);
  });

  React.useEffect(() => {
    return () => {
      updateIntercomWidget(0);
    };
  }, []);

  return rightMenuRef;
};
